import React from 'react';
import loadable from '@loadable/component';
import CookiePolicyPopup from './CookiePolicyPopup';
import LoginAndRegisterPopUp from './LoginAndRegisterPopUp';
import AccountFlyout from './AccountFlyout';
import PDPZoomFlyout from './PDPZoomFlyout';
import FiltersFlyout from './FiltersFlyout';
import { ShopToClub, ShopToClubDoubleOptIn } from './ShopToClub';
import { OverlayId } from './types';
import { useOverlayStateChecker } from './useOverlayStateChecker';

const NewAccountFlyout = loadable(() => import('./NewAccountFlyout/index'), { ssr: false });
const ProductRatingsOverlay = loadable(() => import('./ProductRatingsOverlay'));
const TwoManHandlingOverlay = loadable(() => import('./TwoManHandlingOverlay'));
const FabricSampleOverlay = loadable(() => import('./FabricSample'));

const Overlays = () => {
    const overlayStateChecker = useOverlayStateChecker();
    const isNewAccountActive = overlayStateChecker(OverlayId.ACCOUNT_MENU);
    const isRatingOverlayActive = overlayStateChecker(OverlayId.RATE_YOUR_PRODUCT);
    const isTwoManHandlingOverlayActive = overlayStateChecker(OverlayId.TWO_MAN_HANDLING);
    const isFabricSampleOverlayActive = overlayStateChecker(OverlayId.FABRIC_SAMPLE_OVERLAY);

    return (
        <div>
            <CookiePolicyPopup />
            <LoginAndRegisterPopUp />
            <AccountFlyout />
            {isNewAccountActive && <NewAccountFlyout />}
            <FiltersFlyout />
            <ShopToClub overlayId={OverlayId.SHOP_TO_CLUB_REGISTRATION_SINGLE_STEP_OVERLAY} />
            <ShopToClub overlayId={OverlayId.SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY} />
            <ShopToClubDoubleOptIn />
            <PDPZoomFlyout />
            {isRatingOverlayActive && <ProductRatingsOverlay />}
            {isTwoManHandlingOverlayActive && <TwoManHandlingOverlay />}
            {isFabricSampleOverlayActive && <FabricSampleOverlay />}
        </div>
    );
};

export default Overlays;
